import { render, staticRenderFns } from "./rename-dialog.vue?vue&type=template&id=7ae9e12d"
import script from "./rename-dialog.vue?vue&type=script&lang=js"
export * from "./rename-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports